import { useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { api, errMsg, photoUrl } from "@/lib/api";
import { getGeo, placeLabel } from "@/lib/jobs";
import { SignaturePad } from "@/components/SignaturePad";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const HandoverDialog = ({ job, kind, onClose, onDone }) => {
  const pickup = kind === "pickup";
  const [f, setF] = useState({ signed_name: "", signature: "", photo: null, note: "" });
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); setF((x) => ({ ...x, photo: null })); const { data } = await api.post("/photos", fd); setF((x) => ({ ...x, photo: data.path })); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/jobs/${job.id}/${pickup ? "collect" : "deliver"}`, { ...f, ...(await getGeo()) });
      toast.success(pickup ? "Collected - time stamped" : "Delivered - well done!");
      onDone();
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[95vh] max-w-lg overflow-y-auto" data-testid="handover-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{pickup ? "Confirm collection" : "Confirm delivery"}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{job.ref} · {placeLabel(pickup ? job.pickup : job.dropoff)}</p>
        <label className="block text-sm font-bold">{pickup ? "Handed over by" : "Received by"} (name)
          <input value={f.signed_name} onChange={(e) => setF({ ...f, signed_name: e.target.value })} className="mt-1 h-14 w-full rounded-xl border bg-background px-3 text-lg" data-testid="handover-name" /></label>
        <div><p className="mb-1 text-sm font-bold">Signature</p><SignaturePad value={f.signature} onChange={(v) => setF((x) => ({ ...x, signature: v }))} /></div>
        <label className="flex min-h-16 cursor-pointer items-center justify-center gap-3 rounded-2xl border-2 border-dashed text-lg font-bold" data-testid="handover-photo-btn">
          {busy && !f.signature ? <Loader2 className="h-6 w-6 animate-spin" /> : <Camera className="h-7 w-7" />} {f.photo ? "Retake photo" : "Take photo (optional)"}
          <input type="file" accept="image/*" capture="environment" onChange={upload} className="hidden" data-testid="handover-photo-input" />
        </label>
        {f.photo && <img src={photoUrl(f.photo)} alt="Handover" className="h-40 w-full rounded-xl object-cover" data-testid="handover-photo-preview" />}
        <input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Note (optional)" className="h-12 w-full rounded-xl border bg-background px-3" data-testid="handover-note" />
        <div className="sticky -bottom-6 -mx-6 bg-background/95 px-6 pb-2 pt-3 backdrop-blur"><button onClick={save} disabled={busy || f.signed_name.trim().length < 2 || !f.signature} data-testid="handover-confirm"
          className={`min-h-16 w-full rounded-2xl text-xl font-black disabled:opacity-40 ${pickup ? "bg-[#FEDC19] text-black" : "bg-emerald-600 text-white"}`}>{pickup ? "CONFIRM COLLECTED" : "CONFIRM DELIVERED"}</button></div>
      </DialogContent>
    </Dialog>
  );
};
